"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInputMessageToBuffer = exports.update = exports.reset = exports.get = void 0;
var minigolf_input_sidecar_1 = require("../multi/minigolf_input-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var namespace = 'minigolf-buffered-messages';
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            bufferedCommands: [],
        };
        reset();
    }
    return _obj;
};
exports.get = get;
function reset(masterSeed) {
    if (masterSeed === void 0) { masterSeed = 0; }
    var obj = exports.get();
    obj.bufferedCommands = [];
}
exports.reset = reset;
function update() {
    var obj = exports.get();
    if (physicsTickManager_sidecar_1.physicsTickManager.get().isPhysicsTickFrame) {
        updateFrame_processMessages();
    }
}
exports.update = update;
function updateFrame_processMessages() {
    var obj = exports.get();
    var commands = obj.bufferedCommands;
    var continueProcessing = true;
    while (continueProcessing && commands.length > 0) {
        var peek = commands[0];
        if (peek.input) {
            var mi = peek.input;
            // Process this message
            commands.shift();
            minigolf_input_sidecar_1.minigolf_input.execute(mi);
        }
    }
}
function addInputMessageToBuffer(msg) {
    var obj = exports.get();
    obj.bufferedCommands.push({ input: msg });
}
exports.addInputMessageToBuffer = addInputMessageToBuffer;
